module.exports = __webpack_public_path__ + "static/index/img/baikal-708.2f3a3475.jpg";